const INITIAL_STATE = {
  currentPage: 1,
  pageSize: 50,
  selectedFilters: [],
};

export default INITIAL_STATE;
